import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { DISPLAY_CONSTS } from './excel-icon.constants';

@Component({
  selector: 'app-excel-icon',
  templateUrl: './excel-icon.component.html',
  styleUrls: ['./excel-icon.component.scss'],
  standalone: false,
})
export class ExcelIconComponent {
  @Input() isDisabled = false;
  @Output() exportExcelEvent = new EventEmitter();

  readonly DISP_CONSTS = DISPLAY_CONSTS;
  readonly IMAGES = IMAGE_SRC;

  sendExportExcelSignal() {
    if (!this.isDisabled) {
      this.exportExcelEvent.emit(true);
    }
  }
}
